import React, { useContext } from 'react';
import { formatCustomerName, toFormattedDate } from '@app/utilities';
import { AccountContext, useAccountContext } from '../AccountContext';
import { Link } from 'react-router-dom';
import { useAccountById } from '@app/sdk';
import { FormProvider, useForm } from 'react-hook-form';
import { FormContainer, Input } from '@app/shared';
import { List } from 'semantic-ui-react';
import { Item } from '../../../shared/Item';
import { useCustomerByAccountNumber } from '../../../sdk/cus/UseCustomerByAccountNumber';
import { useRefreshCustomer } from '../../../sdk/cus/UseRefreshCustomer';
import { useAssociateAccount } from '../../../sdk/cus/UseAssociateAccount';

export default function CustomerSummary() {
  const { accountId } = useContext(AccountContext);

  const { data: account, isLoading } = useAccountById(accountId);
  const { data: customer } = useCustomerByAccountNumber(account?.accountNumber);

  return (
    <div className="ui segment">
      <div className="ui header">Customer</div>
      <div className="content">
        {isLoading && <div className="ui active centered inline loader" />}
        {!isLoading && !customer && (
          <>
            <p>No Customer Associated</p>
            <CustomerAssociateForm />
          </>
        )}
        {!isLoading && customer && (
          <List>
            <Item header={'Id:'} description={customer.id} />
            <Item header={'Name:'} description={formatCustomerName(customer)} />
            <Item header={'External Id:'} description={customer.externalId} />
            <Item header={'Date of Birth:'} description={toFormattedDate(customer.dateOfBirth)} />
            <Link to={`/customers/${customer.id}`} className="ui button">
              View Customer
            </Link>
          </List>
        )}
      </div>
    </div>
  );
}

function CustomerAssociateForm() {
  const { accountId } = useAccountContext();
  const formContext = useForm();

  const { mutateAsync: associateAccount, isPending } = useAssociateAccount();
  const refreshCustomer = useRefreshCustomer();
  const onAssociateClicked = async (data: { customerId: string }) => {
    await associateAccount({ customerId: data.customerId, accountId: accountId });
    refreshCustomer();
  };
  return (
    <FormProvider {...formContext}>
      <FormContainer isSubmitting={isPending} onSubmit={onAssociateClicked}>
        <Input
          options={{ required: 'Customer Id is required' }}
          name={'customerId'}
          label={'Customer Id'}
          defaultValue={''}
          width={'ten'}
        />
      </FormContainer>
    </FormProvider>
  );
}
